// 获取模块主要获取数据模块
import request from '@/utils/request';
// 获取数据
export const getHandleJournal = (current, size, name) => request({url: `/look/log/getLogPage?current=${current}&size=${size}&name=${name}`, method: 'get'})